import React, { useEffect, useState, startTransition } from 'react';
import Particles from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import { RingLoader } from 'react-spinners';
import Typewriter from 'typewriter-effect';
import '../assets/css/LoadingSpinnerWithBackground.css'; // Import CSS for transitions

const LoadingSpinnerWithBackground = ({ setLoading }) => {
  const [init, setInit] = useState(false);
  const [isInitialLoad] = useState(true); // Track initial load  // , setIsInitialLoad is the thing if required we can add

  // Initialize the particles engine once
  useEffect(() => {
    const initializeParticles = async () => {
      await import('@tsparticles/react').then((module) =>
        module.initParticlesEngine(async (engine) => {
          await loadSlim(engine);
        })
      );
      setInit(true); // Initialize particles once ready
    };

    initializeParticles();

    // Only add the delay for initial load
    if (isInitialLoad) {
      const timer = setTimeout(() => {
        startTransition(() => {
          setLoading(false); // Set loading to false after the delay
        });
      }, 3000); // 3 seconds for the first time

      // Cleanup the timer
      return () => clearTimeout(timer);
    } else {
      // No additional delay on subsequent loads
      setLoading(false);
    }
  }, [isInitialLoad, setLoading]);

  // Handle page transitions smoothly
  useEffect(() => {
    if (!isInitialLoad) {
      setLoading(false); // Ensure that the loading state is set to false on route change
    }
  }, [isInitialLoad, setLoading]);

  // Particles Options
  const particlesOptions = {
    background: {
      color: {
        value: '#f0f8ff',
      },
    },
    fpsLimit: 60,
    interactivity: {
      events: {
        onClick: {
          enable: true,
          mode: 'push',
        },
        onHover: {
          enable: true,
          mode: 'repulse',
        },
        resize: true,
      },
      modes: {
        push: {
          quantity: 4,
        },
        repulse: {
          distance: 150,
          duration: 0.4,
        },
      },
    },
    particles: {
      color: {
        value: '#4A90E2',
      },
      links: {
        enable: true,
        color: '#4A90E2',
        distance: 120,
        opacity: 0.5,
        width: 1,
      },
      move: {
        enable: true,
        speed: 2,
        outModes: {
          default: 'bounce',
        },
      },
      number: {
        value: 100,
        density: {
          enable: true,
          area: 800,
        },
      },
      opacity: {
        value: 0.7,
      },
      shape: {
        type: 'circle',
      },
      size: {
        value: { min: 1, max: 3 },
        random: true,
      },
    },
    detectRetina: true,
  };

  return (
    <div className={`relative w-full h-screen overflow-hidden ${!isInitialLoad ? 'fade-out' : ''}`}>
      {/* Particles Background */}
      {init && (
        <Particles
          id="tsparticles"
          options={particlesOptions}
          className="absolute inset-0 z-0"
        />
      )}

      {/* Center Content */}
      <div className="relative flex flex-col justify-center items-center min-h-screen z-10">
        {/* Spinner */}
        <RingLoader color="#4A90E2" loading size={150} />
        
        {/* Typewriter Text */}
        <div className="mt-6 text-3xl font-semibold text-slate-800 text-center">
          Welcome to
          <Typewriter
            options={{
              strings: ['GENXZAI'],
              autoStart: true,
              loop: true,
              delay: 50,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinnerWithBackground;
